import {ACTION_TYPE} from "utils/constants";
import View from "./View";

import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {changeProperty} from "store/actions/asset";
import {playAudioPlayer, stopAudioPlayer} from "store/actions/audioPlayer";
import {Color} from "three";
import {setCodeEditor, setCurrentScript} from "store/actions/codeEditor";
import {TwoBtnPopUp, showPopUp} from "components/PopUp";

function Container(props) {
  const dispatch = useDispatch();

  // Connect
  const {selectedObjects, scenes} = useSelector(state => state.asset);
  const audioPlayer = useSelector(state => state.audioPlayer);
  const codeEditor = useSelector(state => state.codeEditor);
  const versionCompatibility = useSelector(state => state.version.versionCompatibility);

  // State
  const [selectedObject, setSelectedObject] = useState(false);
  const [scene, setScene] = useState(scenes.default);
  const [backgroundColor, setBackgroundColor] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [scriptIndex, setScriptIndex] = useState(undefined);

  // Text
  const textOnChange = e => {
    const {name, value} = e.target;

    switch (name) {
      case "Title":
        dispatch(changeProperty(createAction({category: "title", name: "title", value: value})));
        break;
      case "VideoSource":
        dispatch(changeProperty(createAction({category: "video", name: "source", value: value})));
        break;
      case "TextInput":
        dispatch(changeProperty(createAction({category: "text", name: "source", value: value})));
        break;
      case "pId":
        dispatch(changeProperty(createAction({category: "portal", name: "pid", value: value})));
        break;
      case "ServerScriptTitle":
        dispatch(changeProperty(createAction({category: "script", name: "serverScriptTitle", value: {title: value, index: scriptIndex}})));
        break;
      case "ClientScriptTitle":
        dispatch(changeProperty(createAction({category: "script", name: "clientScriptTitle", value: {title: value, index: scriptIndex}})));
        break;
      default:
        break;
    }
  };

  // Transform
  const transformOnChange = e => {
    const {name, value} = e.target;
    const oldCursorPosition = e.target.selectionStart;        
    switch (name) {
      case "Position-x":
        dispatch(changeProperty(createAction({category: "position", name: "x", value: value})));
        break;
      case "Position-y":
        dispatch(changeProperty(createAction({category: "position", name: "y", value: value})));
        break;
      case "Position-z":
        dispatch(changeProperty(createAction({category: "position", name: "z", value: value})));
        break;
      case "Rotation-x":
        dispatch(changeProperty(createAction({category: "rotation", name: "x", value: value})));
        break;
      case "Rotation-y":
        dispatch(changeProperty(createAction({category: "rotation", name: "y", value: value})));
        break;
      case "Rotation-z":
        dispatch(changeProperty(createAction({category: "rotation", name: "z", value: value})));
        break;
      case "Scale-x":
        dispatch(changeProperty(createAction({category: "scale", name: "x", value: value})));
        break;
      case "Scale-y":
        dispatch(changeProperty(createAction({category: "scale", name: "y", value: value})));
        break;
      case "Scale-z":
        dispatch(changeProperty(createAction({category: "scale", name: "z", value: value})));
        break;
      case "Offset-x":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "offsetX",
              value: value,
            }),
          ),
        );
        break;
      case "Offset-y":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "offsetY",
              value: value,
            }),
          ),
        );
        break;
      case "Repeat-x":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "repeatX",
              value: value,
            }),
          ),
        );
        break;
      case "Repeat-y":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "repeatY",
              value: value,
            }),
          ),
        );
        break;
      case "Target-x":
        dispatch(
          changeProperty(
            createAction({
              category: "light",
              name: "target-x",
              value: value,
            }),
          ),
        );
        break;
      case "Target-y":
        dispatch(
          changeProperty(
            createAction({
              category: "light",
              name: "target-y",
              value: value,
            }),
          ),
        );
        break;
      case "Target-z":
        dispatch(
          changeProperty(
            createAction({
              category: "light",
              name: "target-z",
              value: value,
            }),
          ),
        );
        break;
      case "EmitAmount-min":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "emitAmount-min",
              value: value,
            }),
          ),
        );
        break;
      case "EmitAmount-max":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "emitAmount-max",
              value: value,
            }),
          ),
        );
        break;
      case "EmitRate-min":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "emitRate-min",
              value: value,
            }),
          ),
        );
        break;
      case "EmitRate-max":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "emitRate-max",
              value: value,
            }),
          ),
        );
        break;
      case "ParticleLife-min":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "particleLife-min",
              value: value,
            }),
          ),
        );
        break;
      case "ParticleLife-max":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "particleLife-max",
              value: value,
            }),
          ),
        );
        break;
      case "ParticleMass-min":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "particleMass-min",
              value: value,
            }),
          ),
        );
        break;
      case "ParticleMass-max":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "particleMass-max",
              value: value,
            }),
          ),
        );
        break;
      case "RadialDirection-x":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "radialDirection-x",
              value: value,
            }),
          ),
        );
        break;
      case "RadialDirection-y":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "radialDirection-y",
              value: value,
            }),
          ),
        );
        break;
      case "RadialDirection-z":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "radialDirection-z",
              value: value,
            }),
          ),
        );
        break;
      case "Attraction-x":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "attraction-x",
              value: value,
            }),
          ),
        );
        break;
      case "Attraction-y":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "attraction-y",
              value: value,
            }),
          ),
        );
        break;
      case "Attraction-z":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "attraction-z",
              value: value,
            }),
          ),
        );
        break;
      case "Force-x":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "force-x",
              value: value,
            }),
          ),
        );
        break;
      case "Force-y":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "force-y",
              value: value,
            }),
          ),
        );
        break;
      case "Force-z":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "force-z",
              value: value,
            }),
          ),
        );
        break;
      case "RandomDrift-x":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "randomDrift-x",
              value: value,
            }),
          ),
        );
        break;
      case "RandomDrift-y":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "randomDrift-y",
              value: value,
            }),
          ),
        );
        break;
      case "RandomDrift-z":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "randomDrift-z",
              value: value,
            }),
          ),
        );
        break;
      case "SpringDirection-x":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "springDirection-x",
              value: value,
            }),
          ),
        );
        break;
      case "SpringDirection-y":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "springDirection-y",
              value: value,
            }),
          ),
        );
        break;
      case "SpringDirection-z":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "springDirection-z",
              value: value,
            }),
          ),
        );
        break;
      case "Center-x":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteCenter",
              name: "centerX",
              value: value,
            }),
          ),
        );
        break;
      case "Center-y":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteCenter",
              name: "centerY",
              value: value,
            }),
          ),
        );
        break;
      case "SpriteOffset-x":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteOffset",
              name: "offsetX",
              value: value,
            }),
          ),
        );
        break;
      case "SpriteOffset-y":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteOffset",
              name: "offsetY",
              value: value,
            }),
          ),
        );
        break;
      case "SpriteSize-x":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteSize",
              name: "sizeX",
              value: value,
            }),
          ),
        );
        break;
      case "SpriteSize-y":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteSize",
              name: "sizeY",
              value: value,
            }),
          ),
        );
        break;
      default:
        break;
    }
    setTimeout(() => {
      e.target.setSelectionRange(oldCursorPosition, oldCursorPosition);
    });     
  };

  // Color
  const colorOnChange = (name, color) => {
    if (name === "MeshColor") {
      dispatch(changeProperty(createAction({category: "material", name: "color", value: color.hex})));
    } else if (name === "LightColor") {
      dispatch(changeProperty(createAction({category: "light", name: "color", value: color.hex})));
    } else if (name === "BackgroundColor") {
      dispatch(
        changeProperty(
          createAction({
            category: "background",
            name: "color",
            value: color.hex,
          }),
        ),
      );
    } else if (name === "BackgroundTexture") {
      dispatch(
        changeProperty(
          createAction({
            category: "background",
            name: "texture",
            value: color.hex,
          }),
        ),
      );
    } else if (name === "FogColor") {
      dispatch(changeProperty(createAction({category: "fog", name: "color", value: color.hex})));
    } else if (name === "FontColor") {
      dispatch(changeProperty(createAction({category: "text", name: "color", value: color.hex})));
    } else if (name === "SSAOColor") {
      dispatch(changeProperty(createAction({category: "ssao", name: "color", value: color.hex})));
    } else if (name === "Emissive") {
      dispatch(
        changeProperty(
          createAction({
            category: "material",
            name: "emissive",
            value: color.hex,
          }),
        ),
      );
    } else if (name === "GodraysColor") {
      dispatch(changeProperty(createAction({category: "godrays", name: "color", value: color.hex})));
    } else if (name === "LightColor") {
      dispatch(
        changeProperty(
          createAction({
            category: "hemisphereLight",
            name: "color",
            value: color.hex,
          }),
        ),
      );
    } else if (name === "GroundColor") {
      dispatch(
        changeProperty(
          createAction({
            category: "hemisphereLight",
            name: "groundColor",
            value: color.hex,
          }),
        ),
      );
    } else if (name === "ColorStart") {
      dispatch(
        changeProperty(
          createAction({
            category: "particleSystem",
            name: "colorStart",
            value: color.hex,
          }),
        ),
      );
    } else if (name === "ColorEnd") {
      dispatch(
        changeProperty(
          createAction({
            category: "particleSystem",
            name: "colorEnd",
            value: color.hex,
          }),
        ),
      );
    }
  };

  // Behavior
  const checkboxOnChange = (name, e) => {
    switch (name) {
      case "Shadow":
        dispatch(
          changeProperty(
            createAction({
              category: "shadow",
              name: "shadow",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "CanCollide":
        dispatch(
          changeProperty(
            createAction({
              category: "cancollide",
              name: "cancollide",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Static":
        dispatch(
          changeProperty(
            createAction({
              category: "static",
              name: "static",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Anchored":
        dispatch(
          changeProperty(
            createAction({
              category: "anchored",
              name: "anchored",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Massless":
        dispatch(
          changeProperty(
            createAction({
              category: "massless",
              name: "massless",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "FogActive":
        dispatch(
          changeProperty(
            createAction({
              category: "fog",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "DobuleSide":
        dispatch(
          changeProperty(
            createAction({
              category: "video",
              name: "doubleside",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "VideoMute":
        dispatch(
          changeProperty(
            createAction({
              category: "video",
              name: "mute",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "AutoPlay":
        dispatch(
          changeProperty(
            createAction({
              category: "video",
              name: "autoplay",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Script":
        dispatch(
          changeProperty(
            createAction({
              category: "script",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Audio":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Offset":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "offsetActive",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Duration":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "durationActive",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "AudioAutoplay":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "autoplay",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Positional":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "positional",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Directional":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "directional",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Loop":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "loop",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "LoopStart":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "loopStartActive",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "LoopEnd":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "loopEndActive",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "SSAO":
        dispatch(
          changeProperty(
            createAction({
              category: "ssao",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Bloom":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Luminance":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "luminance",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Inverted":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "inverted",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "God-rays":
        dispatch(
          changeProperty(
            createAction({
              category: "godrays",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "HueSaturation":
        dispatch(
          changeProperty(
            createAction({
              category: "hueSaturation",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "BrightnessContrast":
        dispatch(
          changeProperty(
            createAction({
              category: "brightnessContrast",
              name: "active",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Map":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "map-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Normal Map":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "normalMap-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Env Map":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "envMap-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Equirect":
        dispatch(
          changeProperty(
            createAction({
              category: "environment",
              name: "checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "AttractionActive":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "attraction-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "ForceActive":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "force-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "RandomDriftActive":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "randomDrift-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "SpringActive":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "spring-checkbox",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Maintain AspectRatio":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteSize",
              name: "aspectRatio",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "Body":
        dispatch(
          changeProperty(
            createAction({
              category: "body",
              name: "body",
              value: e.target.checked,
            }),
          ),
        );
        break;
      case "CameraEnabled":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "enabled",
              value: e.target.checked,
            }),
          ),
        );
        break;
      default:
        break;
    }
  };

  const inputOnChange = (name, value, e) => {
    let oldCursorPosition = undefined;
    if (e) oldCursorPosition = e?.target?.selectionStart;

    switch (name) {
      case "Transparency":
        if (value > 100) {
          value = 100;            // percentage must be < 100
        } 
        if (e && e.target) {
          e.target.addEventListener("keydown", keyEvent => {
            if (keyEvent.key === "-") {
              keyEvent.preventDefault();
            }
          });
        }
        dispatch(
          changeProperty(
            createAction({
              category: "transparency",
              name: "transparency",
              value: value / 100,
            }),
          ),
        );
        break;
      case "Brightness":
        dispatch(changeProperty(createAction({category: "light", name: "intensity", value: value})));
        break;
      case "Exposure":
        dispatch(
          changeProperty(
            createAction({
              category: "tone",
              name: "exposure",
              value: Number(value),
            }),
          ),
        );
        break;
      case "FogDensity":
        dispatch(
          changeProperty(
            createAction({
              category: "fog",
              name: "density",
              value: Number(value),
            }),
          ),
        );
        break;
      case "FogNear":
        dispatch(changeProperty(createAction({category: "fog", name: "near", value: Number(value)})));
        break;
      case "FogFar":
        dispatch(changeProperty(createAction({category: "fog", name: "far", value: Number(value)})));
        break;
      case "FontSize":
        dispatch(
          changeProperty(
            createAction({
              category: "text",
              name: "size",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Volume":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "volume",
              value: Number(value),
            }),
          ),
        );
        break;
      case "PlaybackRate":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "playbackRate",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Offset":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "offset",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Duration":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "duration",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Ref Distance":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "refDistance",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Max Distance":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "maxDistance",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Rolloff Factor":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "rolloffFactor",
              value: Number(value),
            }),
          ),
        );
        break;
      case "InnerAngle":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "innerAngle",
              value: Number(value),
            }),
          ),
        );
        break;
      case "OuterAngle":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "outerAngle",
              value: Number(value),
            }),
          ),
        );
        break;
      case "OuterGain":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "outerGain",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Loop Start":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "loopStart",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Loop End":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "loopEnd",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Bias":
        dispatch(
          changeProperty(
            createAction({
              category: "ssao",
              name: "bias",
              value: Number(value),
            }),
          ),
        );
        break;
      case "SSAOIntensity":
        dispatch(
          changeProperty(
            createAction({
              category: "ssao",
              name: "intensity",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Fade":
        dispatch(
          changeProperty(
            createAction({
              category: "ssao",
              name: "fade",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Map":
        selectedObject.userData["map"] = value;
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "map-input",
              value: selectedObject.userData["map"],
            }),
          ),
        );
        break;
      case "Normal Map":
        selectedObject.userData["normalMap"] = value;
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "normalMap-input",
              value: selectedObject.userData["normalMap"],
            }),
          ),
        );
        break;
      case "Env Map":
        selectedObject.userData["envMap"] = value;
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "envMap-input",
              value: selectedObject.userData["envMap"],
            }),
          ),
        );
        break;
      case "Opacity":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "opacity",
              value: value,
            }),
          ),
        );
        break;
      case "BloomIntensity":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "intensity",
              value: Number(value),
            }),
          ),
        );
        break;
      case "BloomRadius":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "radius",
              value: Number(value),
            }),
          ),
        );
        break;
      case "BloomOpacity":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "opacity",
              value: Number(value),
            }),
          ),
        );
        break;
      case "LuminanceThreshold":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "threshold",
              value: Number(value),
            }),
          ),
        );
        break;
      case "LuminanceSmoothing":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "smoothing",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Hue":
        dispatch(
          changeProperty(
            createAction({
              category: "hueSaturation",
              name: "hue",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Saturation":
        dispatch(
          changeProperty(
            createAction({
              category: "hueSaturation",
              name: "saturation",
              value: Number(value),
            }),
          ),
        );
        break;
      case "HSVOpacity":
        dispatch(
          changeProperty(
            createAction({
              category: "hueSaturation",
              name: "opacity",
              value: Number(value),
            }),
          ),
        );
        break;
      case "BCBrightness":
        dispatch(
          changeProperty(
            createAction({
              category: "brightnessContrast",
              name: "brightness",
              value: Number(value),
            }),
          ),
        );
        break;
      case "BCContrast":
        dispatch(
          changeProperty(
            createAction({
              category: "brightnessContrast",
              name: "contrast",
              value: Number(value),
            }),
          ),
        );
        break;
      case "BCOpacity":
        dispatch(
          changeProperty(
            createAction({
              category: "brightnessContrast",
              name: "opacity",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Rotation":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "rotation",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Shininess":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "shininess",
              value: Number(value),
            }),
          ),
        );
        break;
      case "GodraysWeight":
        dispatch(
          changeProperty(
            createAction({
              category: "godrays",
              name: "weight",
              value: Number(value),
            }),
          ),
        );
        break;
      case "GodraysDensity":
        dispatch(
          changeProperty(
            createAction({
              category: "godrays",
              name: "density",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Emissive":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "emissiveIntensity",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Distance":
        dispatch(
          changeProperty(
            createAction({
              category: "light",
              name: "distance",
              value: Number(value),
            }),
          ),
        );
        break;
      case "RadialSpeed":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "radialSpeed",
              value: Number(value),
            }),
          ),
        );
        break;
      case "RadialDegree":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "radialDegree",
              value: Number(value),
            }),
          ),
        );
        break;
      case "AlphaStart":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "alphaStart",
              value: Number(value),
            }),
          ),
        );
        break;
      case "AlphaEnd":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "alphaEnd",
              value: Number(value),
            }),
          ),
        );
        break;
      case "ScaleStart":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "scaleStart",
              value: Number(value),
            }),
          ),
        );
        break;
      case "ScaleEnd":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "scaleEnd",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Attraction Force":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "attractionForce",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Spring Factor":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "springFactor",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Spring Friction":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "springFriction",
              value: Number(value),
            }),
          ),
        );
        break;
      case "Particle Texture":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "particleTexture-input",
              value: value,
            }),
          ),
        );
        break;
      case "Equirect":
        dispatch(
          changeProperty(
            createAction({
              category: "environment",
              name: "input",
              value: value,
            }),
          ),
        );
        break;
      case "Mass":
        dispatch(
          changeProperty(
            createAction({
              category: "mass",
              name: "mass",
              value: value,
            }),
          ),
        );
        break;
      case "Friction":
        dispatch(
          changeProperty(
            createAction({
              category: "friction",
              name: "friction",
              value: value,
            }),
          ),
        );
        break;
      case "DefaultTexture":
        dispatch(
          changeProperty(
            createAction({
              category: "background",
              name: "default",
              value: undefined, 
            }),
          ),
        );
        break;
      case "BackgroundTexture":
        dispatch(
          changeProperty(
            createAction({
              category: "background",
              name: "texture",
              value: value,
            }),
          ),
        );
        break;
      case "CameraDepth":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "depth",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraFov":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "fov",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraLeft":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "left",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraRight":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "right",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraTop":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "top",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraBottom":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "bottom",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraNear":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "near",
              value: Number(value),
            }),
          ),
        );
        break;
      case "CameraFar":
        dispatch(
          changeProperty(
            createAction({
              category: "camera",
              name: "far",
              value: Number(value),
            }),
          ),
        );
        break;
      default:
        break;
    }
    if (e && e?.target?.type === 'text') {
      setTimeout(() => {
        e?.target?.setSelectionRange(oldCursorPosition, oldCursorPosition);
      });
    }
  };

  const dropdownOnChange = (name, value) => {
    switch (name) {
      case "FogMode":
        dispatch(changeProperty(createAction({category: "fog", name: "mode", value: value})));
        break;
      case "ToneMappingMode":
        dispatch(changeProperty(createAction({category: "tone", name: "mode", value: value})));
        break;
      case "Font":
        dispatch(changeProperty(createAction({category: "text", name: "font", value: value})));
        break;
      case "FontWeight":
        dispatch(changeProperty(createAction({category: "text", name: "weight", value: value})));
        break;
      case "Distance Model":
        dispatch(
          changeProperty(
            createAction({
              category: "audio",
              name: "distanceModel",
              value: value,
            }),
          ),
        );
        break;
      case "Side":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "side",
              value: value,
            }),
          ),
        );
        break;
      case "Blending":
        dispatch(
          changeProperty(
            createAction({
              category: "material",
              name: "blending",
              value: value,
            }),
          ),
        );
        break;
      case "Preset":
        dispatch(
          changeProperty(
            createAction({
              category: "particleSystem",
              name: "preset",
              value: value,
            }),
          ),
        );
        break;
      case "BodyType":
        dispatch(
          changeProperty(
            createAction({
              category: "bodyType",
              name: "bodyType",
              value: value,
            }),
          ),
        );
        break;
      case "AnchorX":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteAnchor",
              name: "anchorX",
              value: value,
            }),
          ),
        );
        break;
      case "AnchorY":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteAnchor",
              name: "anchorY",
              value: value,
            }),
          ),
        );
        break;
      case "OffsetX":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteOffset",
              name: "offsetUnitX",
              value: value,
            }),
          ),
        );
        break;
      case "OffsetY":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteOffset",
              name: "offsetUnitY",
              value: value,
            }),
          ),
        );
        break;
      case "SizeX":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteSize",
              name: "sizeUnitX",
              value: value,
            }),
          ),
        );
        break;
      case "SizeY":
        dispatch(
          changeProperty(
            createAction({
              category: "spriteSize",
              name: "sizeUnitY",
              value: value,
            }),
          ),
        );
        break;
      case "HSVBlendMode":
        dispatch(
          changeProperty(
            createAction({
              category: "hueSaturation",
              name: "blendFunction",
              value: value,
            }),
          ),
        );
        break;
      case "BCBlendMode":
        dispatch(
          changeProperty(
            createAction({
              category: "brightnessContrast",
              name: "blendFunction",
              value: value,
            }),
          ),
        );
        break;
      case "BloomBlendMode":
        dispatch(
          changeProperty(
            createAction({
              category: "bloom",
              name: "blendFunction",
              value: value,
            }),
          ),
        );
        break;
      default:
        break;
    }
  };

  const createAction = ({category, name, value}) => {
    return {
      command: ACTION_TYPE.CHANGE_PROPERTY,
      category,
      name,
      value,
    };
  };

  // const playPreviewAudio = path => {
  //   setIsAudioPlaying(true);
  //   dispatch(playAudioPlayer({source: path, component: "Properties"}));
  // };

  const stopPreviewAudio = () => {
    setIsAudioPlaying(false);
    dispatch(stopAudioPlayer());
  };

  const addUserScript = type => {
    if (type === "serverScript") {
      dispatch(
        changeProperty(
          createAction({
            category: "script",
            name: "addServerScript",
          }),
        ),
      );
    } else if (type === "clientScript") {
      dispatch(
        changeProperty(
          createAction({
            category: "script",
            name: "addClientScript",
          }),
        ),
      );
    }
  };

  const editUserScript = (type, index, title, source, target) => {
    const object = target ? target : selectedObjects[0] || scenes["default"];
    dispatch(setCurrentScript({objUuid: object.uuid, type: type, index: index, title: title, source: source}));
    dispatch(setCodeEditor(false));
    setTimeout(() => {
      dispatch(setCodeEditor(true));
    }, 100);
  };

  const removeUserScript = (type, title, index) => {
    showPopUp(
      <TwoBtnPopUp
        title={`Are you sure to remove the script? ${title}`}
        confirmBtn={"Confirm"}
        cancelBtn={"Cancel"}
        confirmAction={() => {
          if (type === "serverScript") {
            dispatch(
              changeProperty(
                createAction({
                  category: "script",
                  name: "removeServerScript",
                  value: index,
                }),
              ),
            );
          } else if (type === "clientScript") {
            dispatch(
              changeProperty(
                createAction({
                  category: "script",
                  name: "removeClientScript",
                  value: index,
                }),
              ),
            );
          }
          if (codeEditor.isOpen && codeEditor.currentScript.index === index && !codeEditor.showScriptList) {
            dispatch(setCodeEditor(false));
          }
        }}
      />,
      {
        defaultPadding: false,
        noBackground: true,
      },
    );
  };

  useEffect(() => {
    setSelectedObject(selectedObjects[0]);
    if (isAudioPlaying) stopPreviewAudio();
  }, [selectedObjects]);

  useEffect(() => {
    setScene(scenes.default);
  }, [scenes]);

  useEffect(() => {
    if (scenes.default.background instanceof Color) {
      setBackgroundColor(scenes.default.background);
    }
  }, [scenes.default.background]);

  useEffect(() => {
    if (!audioPlayer.isPlaying || audioPlayer.playingComponent !== "Properties") setIsAudioPlaying(false);
  }, [audioPlayer]);

  return (
    <View
      currentTab={props.currentTab}
      selectedObject={selectedObject}
      scene={scene}
      versionCompatibility={versionCompatibility}
      backgroundColor={backgroundColor}
      textOnChange={textOnChange}
      transformOnChange={transformOnChange}
      colorOnChange={colorOnChange}
      checkboxOnChange={checkboxOnChange}
      inputOnChange={inputOnChange}
      dropdownOnChange={dropdownOnChange}
      // isAudioPlaying={isAudioPlaying}
      // playPreviewAudio={playPreviewAudio}
      // stopPreviewAudio={stopPreviewAudio}
      setScriptIndex={setScriptIndex}
      addUserScript={addUserScript}
      editUserScript={editUserScript}
      removeUserScript={removeUserScript}
    />
  );
}

export default Container;

